/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {useSelector} from "react-redux";

export function QuickUserToggler() {
    const {user, avatar} = useSelector(state => state.auth);

    const getAvatar = () => {
        return avatar ?
            (
                <span className="symbol-label font-size-h5 font-weight-bold"
                      style={{backgroundImage: `url(${avatar})`}}></span>
            )
            : (<span className="symbol-label font-size-h5 font-weight-bold">{user.firstname[0]}</span>);
    }

    return (
        <div className="topbar-item">
            <div className="btn btn-icon w-auto btn-topbar d-flex align-items-center btn-lg px-2"
                 id="od_quick_user_toggle">
                <span className="text-white font-weight-bold font-size-base d-none d-md-inline mr-1">
                    Hi,
                </span>
                <span className="text-white-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
                  {user.firstname}
                </span>
                <span className="symbol symbol-35 symbol-light-success">
                    {getAvatar()}
                </span>
            </div>
        </div>
    );
}
